import React from 'react';
import ReactDOM from 'react-dom';
import {
    Grid,
    Button
} from 'react-bootstrap';
import './Subentries.css';
import Dict from 'dict-lib';
import './../../../../_css/lexeme.css';
import {MorphoRuleGridLayout} from "../../../languageSettings/morphoRules/MorphoRuleGridLayout";
import {TreeDOMHelper} from "../../../../dict-components/tree/components/TreeHelper";

export class SubFormsTemplate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ruleId: '',
            mode: 'PRINT',
            printMode: 'FULL',
        };
    }

    componentWillMount() {
        Dict.call('/subentries/retrieveStoredRuleId/' + this.props.item.ids + '/').then((ruleId) => {
            this.setState({ruleId}, () => {
                this._mountTemplate();
            });
        });
    }

    _mountTemplate() {
        ReactDOM.render(<MorphoRuleGridLayout ruleId={this.state.ruleId} subentryId={this.props.item.ids}
                                              mode={this.state.mode}
                                              printMode={this.state.printMode}/>, document.getElementById('subentry-forms-template-morpho'));
    }

    render() {
        return this.state.ruleId !== '' ? <div className={'subentry-forms-template-container'}>
            <div id={'subentry-forms-template-morpho'} className={'subentry-forms-template-morpho'}/>
            <div className={'subentry-forms-template-button'}>
                {this.state.mode === 'PRINT' ? <>
                    <Button onClick={() => {

                    }}>{Dict.t('EXPORT_PDF')}</Button>
                    <Button onClick={() => {
                    ReactDOM.unmountComponentAtNode(document.getElementById('subentry-forms-template-morpho'));
                    var printMode = this.state.printMode === 'RESTRICTED' ? 'FULL' : 'RESTRICTED';
                    this.setState({printMode}, () => {
                        this._mountTemplate();
                    });
                }}>{Dict.t(this.state.printMode === 'FULL' ? 'TO_RESTRICTED_PRINT_MODE' : 'TO_FULL_PRINT_MODE')}</Button>
                </> : ''}
                <Button onClick={() => {
                    ReactDOM.unmountComponentAtNode(document.getElementById('subentry-forms-template-morpho'));
                    var mode = this.state.mode === 'EDIT' ? 'PRINT' : 'EDIT';
                    this.setState({mode}, () => {
                        this._mountTemplate();
                    });
                }}>{Dict.t(this.state.mode === 'EDIT' ? 'TO_PRINT_MODE' : 'TO_EDIT_MODE')}</Button>
            </div>
        </div> : '';
    }
}